import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Cadastro rápido de solicitante no formulário do chamado: envia o mini formulário do
// modal por fetch (sem sair da tela e sem perder o que já foi digitado), acrescenta o novo
// solicitante ao select e o deixa selecionado.
export default class extends Controller {
  static targets = ["select", "nome", "departamento", "telefone", "erro"]
  static values = { url: String }

  async salvar(event) {
    event.preventDefault()
    this.erroTarget.textContent = ""

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const resposta = await fetch(this.urlValue, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-Token": token },
      body: JSON.stringify({
        solicitante: {
          name: this.nomeTarget.value,
          departamento_id: this.departamentoTarget.value,
          telefone: this.telefoneTarget.value,
        },
      }),
    })
    const dados = await resposta.json()

    if (!resposta.ok) {
      this.erroTarget.textContent = (dados.erros || ["Não foi possível cadastrar."]).join(" ")
      return
    }

    this.selectTarget.add(new Option(dados.nome, dados.id, true, true))
    this.nomeTarget.value = ""
    this.telefoneTarget.value = ""

    const modal = this.element.querySelector(".modal")
    Modal.getInstance(modal)?.hide()
  }

  // Ao trocar a área de um chamado novo, recarrega o formulário com os catálogos dela.
  trocarArea(event) {
    const url = new URL(window.location.href)
    url.searchParams.set("area_id", event.target.value)
    window.location.href = url.toString()
  }
}
